import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import moment from "moment";
import { FaCalendar } from "react-icons/fa";
import Meta from "../components/Meta";
import BlogBreadCrumb from "../components/BlogBreadCrumb";
import "../styles/singleBlog.css";

import { useDispatch, useSelector } from "react-redux";
import { getAllBlogs, getABlog } from "../features/blogs/blogSlice";

const SingleBlog = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { blog: blogs = [], isLoading , singleBlog} = useSelector((state) => state.blog);


  useEffect(() => {
    dispatch(getABlog(slug));
    dispatch(getAllBlogs());
  }, [dispatch, slug]);

  if (isLoading || !singleBlog)
    return <h2 style={{ padding: "50px" }}>Loading blog...</h2>;

  const blog = singleBlog;

  const relatedBlogs = Array.isArray(blogs)
  ? blogs.filter((b) => b.slug !== slug).slice(0, 3)
  : [];


    console.log(blogs,"blogs")

  return (
    <>
      <Meta title={blog.title} />
      <BlogBreadCrumb title={blog.title} />

      <div className="blog-wrapper single-blog-container home-wrapper-2">
        <div className="blog-col" style={{ display: "flex", gap: "40px" }}>
          
          {/* MAIN BLOG CONTENT */}
          <div className="blog-content-2-el">
            <div className="single-blog-card-el">

              {/* TITLE + DATE */}
              <div className="single-blog-content">
                <h3 className="title">{blog.title}</h3>

                <div className="blog-date">
                  <FaCalendar className="calendar-icon-el" />
                  <span>{moment(blog.updatedAt).format("MMMM D, YYYY")}</span>
                </div>
              </div>

              {/* ⭐ MAIN BLOG IMAGE HERE ⭐ */}
              {blog.images?.[0]?.url && (
                <div className="single-blog-image">
                  <img
                    src={blog.images[0].url}
                    alt={blog.title}
                    loading="lazy"
                  />
                </div>
              )}

              {/* BLOG CONTENT */}
              <div
                className="blog-paragraph"
                dangerouslySetInnerHTML={{ __html: blog.description }}
              />
            </div>
          </div>

          {/* RELATED BLOGS SIDEBAR */}
          <div className="related-blog-wrapper">
            <div className="related-blog">
              <h4 className="related-title">Related Posts</h4>
              <div className="blog-hr"></div>

              {relatedBlogs?.map((b, i) => (
                <div
                  key={i}
                  className="related-post-card"
                  onClick={() => navigate(`/blogs/${b.slug}`)}
                >
                  <div className="thumbnail">
                    <img src={b.images?.[0]?.url} alt={b.title} />
                  </div>

                  <div className="content">
                    <span className="category">{b.category}</span>
                    <p className="title">{b.title}</p>
                    <span className="date">
                      {moment(b.updatedAt).format("MMMM D, YYYY")}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>

        </div>
      </div>
    </>
  );
};

export default SingleBlog;
